import { c as _c } from "react-compiler-runtime";
import { memo } from 'react';
import { COMMENT_INDICATOR_IDENTIFIER } from 'collaboration-sidebar/constants/identifiers';
import { View } from 'foundations-components/transitional/components/View';
import EmbeddedCommentIndicator from './EmbeddedCommentIndicator';
import { jsx as _jsx } from "react/jsx-runtime";
function EmbeddedComment(t0) {
  "use memo";

  const $ = _c(20);
  const {
    onClose,
    collaborationSidebarState,
    verticalPositioning,
    setIsCommenting,
    iconPosition: t1,
    iconProps,
    renderCommentIndicator,
    moduleParentComment,
    topOffset,
    leftOffset,
    isOpen,
    embeddedCommentWrapperRef,
    toggleOpenPopover
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const iconPosition = t2;
  const t3 = iconPosition.top || `${topOffset}px`;
  const t4 = iconPosition.left || `${leftOffset}px`;
  const t5 = Object.keys(iconPosition).length > 0;
  let t6;
  if ($[2] !== collaborationSidebarState || $[3] !== embeddedCommentWrapperRef || $[4] !== iconProps || $[5] !== isOpen || $[6] !== moduleParentComment || $[7] !== onClose || $[8] !== renderCommentIndicator || $[9] !== setIsCommenting || $[10] !== t5 || $[11] !== toggleOpenPopover || $[12] !== verticalPositioning) {
    t6 = /*#__PURE__*/_jsx(EmbeddedCommentIndicator, {
      collaborationSidebarState: collaborationSidebarState,
      isOpen: isOpen,
      onClose: onClose,
      iconProps: iconProps,
      renderCommentIndicator: renderCommentIndicator,
      setIsCommenting: setIsCommenting,
      verticalPositioning: verticalPositioning,
      hasCustomPosition: t5,
      moduleParentComment: moduleParentComment,
      embeddedCommentWrapperRef: embeddedCommentWrapperRef,
      toggleOpenPopover: toggleOpenPopover
    });
    $[2] = collaborationSidebarState;
    $[3] = embeddedCommentWrapperRef;
    $[4] = iconProps;
    $[5] = isOpen;
    $[6] = moduleParentComment;
    $[7] = onClose;
    $[8] = renderCommentIndicator;
    $[9] = setIsCommenting;
    $[10] = t5;
    $[11] = toggleOpenPopover;
    $[12] = verticalPositioning;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== iconPosition.bottom || $[15] !== iconPosition.right || $[16] !== t3 || $[17] !== t4 || $[18] !== t6) {
    t7 = /*#__PURE__*/_jsx(View, {
      id: COMMENT_INDICATOR_IDENTIFIER,
      position: "absolute",
      insetBlockStart: t3,
      insetInlineStart: t4,
      insetBlockEnd: iconPosition.bottom,
      insetInlineEnd: iconPosition.right,
      children: t6
    });
    $[14] = iconPosition.bottom;
    $[15] = iconPosition.right;
    $[16] = t3;
    $[17] = t4;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
}
export default /*#__PURE__*/memo(EmbeddedComment);